/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import {
  Signer,
  utils,
  BigNumberish,
  Contract,
  ContractFactory,
  Overrides,
} from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  MachineAssembler,
  MachineAssemblerInterface,
} from "../MachineAssembler";

const _abi = [
  {
    inputs: [
      {
        internalType: "contract IERC1155",
        name: "_token",
        type: "address",
      },
      {
        internalType: "uint256[]",
        name: "_gearIds",
        type: "uint256[]",
      },
      {
        internalType: "uint256",
        name: "_mid",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "assemble",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "gearIds",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "mid",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    name: "onERC1155BatchReceived",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    name: "onERC1155Received",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "token",
    outputs: [
      {
        internalType: "contract IERC1155",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";

export class MachineAssembler__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(
    _token: string,
    _gearIds: BigNumberish[],
    _mid: BigNumberish,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<MachineAssembler> {
    return super.deploy(
      _token,
      _gearIds,
      _mid,
      overrides || {}
    ) as Promise<MachineAssembler>;
  }
  getDeployTransaction(
    _token: string,
    _gearIds: BigNumberish[],
    _mid: BigNumberish,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(_token, _gearIds, _mid, overrides || {});
  }
  attach(address: string): MachineAssembler {
    return super.attach(address) as MachineAssembler;
  }
  connect(signer: Signer): MachineAssembler__factory {
    return super.connect(signer) as MachineAssembler__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): MachineAssemblerInterface {
    return new utils.Interface(_abi) as MachineAssemblerInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): MachineAssembler {
    return new Contract(address, _abi, signerOrProvider) as MachineAssembler;
  }
}
